import ApiFavorites from "./ApiFavorites";
var FavoriteModalHandler = /** @class */ (function () {
    function FavoriteModalHandler(baseUri) {
        this.modalInstance = null;
        this.currentProductId = null;
        this.currentProductInLists = [];
        this.isLoading = false;
        this.isSaving = false;
        this.api = new ApiFavorites(baseUri);
        this.modal = document.getElementById('favoriteListModal');
        this.init();
    }
    FavoriteModalHandler.prototype.init = function () {
        var _this = this;
        var _a, _b, _c;
        if (!this.modal)
            return;
        // Create a single Bootstrap modal instance that we'll reuse
        this.modalInstance = new bootstrap.Modal(this.modal);
        // Handle clicks on favorite buttons (event delegation)
        document.addEventListener('click', function (event) {
            var target = event.target;
            var button = target.closest('.btn-favorite');
            if (button && button.dataset.productId) {
                event.preventDefault();
                event.stopPropagation();
                // Reset state
                _this.isLoading = false;
                _this.isSaving = false;
                // Get product data from button
                _this.currentProductId = parseInt(button.dataset.productId || '0');
                var inListsData = button.dataset.inLists;
                _this.currentProductInLists = inListsData ? JSON.parse(inListsData) : [];
                // Open modal and load lists
                _this.modalInstance.show();
                _this.loadLists();
            }
        });
        // Listen for modal hidden event - reset state
        this.modal.addEventListener('hidden.bs.modal', function () {
            _this.isLoading = false;
            _this.isSaving = false;
            _this.currentProductId = null;
            _this.currentProductInLists = [];
        });
        // Create new list button
        (_a = document.getElementById('createNewListBtn')) === null || _a === void 0 ? void 0 : _a.addEventListener('click', function () {
            _this.createNewList();
        });
        // Enter key on new list input
        (_b = document.getElementById('newFavoriteListName')) === null || _b === void 0 ? void 0 : _b.addEventListener('keypress', function (e) {
            if (e.key === 'Enter') {
                e.preventDefault();
                _this.createNewList();
            }
        });
        // Save button
        (_c = document.getElementById('saveFavoriteListsBtn')) === null || _c === void 0 ? void 0 : _c.addEventListener('click', function () {
            _this.saveSelection();
        });
    };
    FavoriteModalHandler.prototype.loadLists = function () {
        var _this = this;
        if (this.isLoading)
            return;
        this.isLoading = true;
        var container = document.getElementById('favoriteListsContainer');
        if (!container) {
            this.isLoading = false;
            return;
        }
        container.innerHTML = '<p class="text-muted text-center"><i class="fas fa-spinner fa-spin"></i> Laden...</p>';
        this.api.getLists(function (lists) {
            _this.isLoading = false;
            if (!lists || lists.length === 0) {
                container.innerHTML = '<p class="text-muted text-center">Nog geen favorietenlijsten. Maak er een hierboven!</p>';
                return;
            }
            var html = '<div class="list-group">';
            lists.forEach(function (list) {
                var isChecked = _this.currentProductInLists.includes(list.id);
                html += "\n                    <label class=\"list-group-item d-flex align-items-center\" style=\"cursor: pointer;\">\n                        <input class=\"form-check-input me-3 favorite-list-checkbox\"\n                               type=\"checkbox\"\n                               value=\"".concat(list.id, "\"\n                               ").concat(isChecked ? 'checked' : '', ">\n                        <span class=\"flex-grow-1\">").concat(_this.escapeHtml(list.name), "</span>\n                        <span class=\"badge bg-secondary\">").concat(list.itemCount, "</span>\n                    </label>\n                ");
            });
            html += '</div>';
            container.innerHTML = html;
        });
    };
    FavoriteModalHandler.prototype.createNewList = function () {
        var _this = this;
        var input = document.getElementById('newFavoriteListName');
        var name = input.value.trim();
        if (!name)
            return;
        var btn = document.getElementById('createNewListBtn');
        btn.disabled = true;
        btn.innerHTML = '<i class="fas fa-spinner fa-spin"></i>';
        this.api.createList(name, function (newList) {
            input.value = '';
            btn.disabled = false;
            btn.innerHTML = '<i class="fas fa-plus"></i>';
            // Add to current selection
            _this.currentProductInLists.push(newList.id);
            _this.loadLists();
        });
    };
    FavoriteModalHandler.prototype.saveSelection = function () {
        var _this = this;
        if (!this.currentProductId || this.isSaving)
            return;
        this.isSaving = true;
        var checkboxes = document.querySelectorAll('.favorite-list-checkbox');
        var selectedListIds = Array.from(checkboxes)
            .filter(function (cb) { return cb.checked; })
            .map(function (cb) { return parseInt(cb.value); });
        var saveBtn = document.getElementById('saveFavoriteListsBtn');
        saveBtn.disabled = true;
        saveBtn.innerHTML = '<i class="fas fa-spinner fa-spin"></i> Opslaan...';
        var productId = this.currentProductId;
        this.api.addProductToLists(productId, selectedListIds).then(function (result) {
            _this.isSaving = false;
            saveBtn.disabled = false;
            saveBtn.innerHTML = '<i class="fas fa-save me-1"></i>Opslaan';
            // Update all favorite buttons with this product ID
            var buttons = document.querySelectorAll(".btn-favorite[data-product-id=\"".concat(productId, "\"]"));
            buttons.forEach(function (button) {
                var isFavorited = result.inLists && result.inLists.length > 0;
                if (isFavorited) {
                    button.classList.add('favorited');
                    button.title = 'In favorietenlijst';
                }
                else {
                    button.classList.remove('favorited');
                    button.title = 'Toevoegen aan favorieten';
                }
                // Replace icon - Font Awesome will convert this to SVG
                button.innerHTML = "<i class=\"fa".concat(isFavorited ? 's' : 'r', " fa-heart\"></i>");
                button.dataset.inLists = JSON.stringify(result.inLists || []);
            });
            // Trigger Font Awesome to convert new <i> elements to SVG
            if (typeof FontAwesome !== 'undefined' && FontAwesome.dom) {
                FontAwesome.dom.i2svg();
            }
            // Close modal
            _this.closeModal();
        }).catch(function (error) {
            console.error('Error saving favorites:', error);
            _this.isSaving = false;
            saveBtn.disabled = false;
            saveBtn.innerHTML = '<i class="fas fa-save me-1"></i>Opslaan';
            _this.closeModal();
        });
    };
    FavoriteModalHandler.prototype.closeModal = function () {
        if (this.modalInstance) {
            this.modalInstance.hide();
        }
    };
    FavoriteModalHandler.prototype.escapeHtml = function (text) {
        var div = document.createElement('div');
        div.textContent = text;
        return div.innerHTML;
    };
    return FavoriteModalHandler;
}());
export default FavoriteModalHandler;
